import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Damage } from '../../../../interfaces/Damages.interfaces';

/**
 * Popup "Pratiche del collo" di /damaged-parcels: elenco di tutte le pratiche danno
 * legate a un collo (aperte, chiuse, respinte), dalla più recente, con il
 * bottone per aprire il dettaglio di ciascuna. Stesso stile dei popup di
 * /dealer-contacts e del popup operazioni del dettaglio pratica.
 */
@Component({
  selector: 'app-parcel-claims-popup',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './parcel-claims-popup.component.html',
  styleUrls: ['./parcel-claims-popup.component.css']
})
export class ParcelClaimsPopupComponent {
  @Input() visible = false;
  @Input() parcelCode = '';
  @Input() claims: Damage[] = [];
  @Output() closed = new EventEmitter<void>();
  /** Richiesta di aprire il dettaglio della pratica (damageId) */
  @Output() openClaim = new EventEmitter<number>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.visible) this.close();
  }

  close(): void {
    this.closed.emit();
  }

  open(claim: Damage): void {
    if (claim?.damageId != null) this.openClaim.emit(Number(claim.damageId));
  }

  isClosed(claim: Damage): boolean {
    return claim.damageStatus === 'CLOSED' || claim.damageStatus === 'REJECTED';
  }

  get openCount(): number {
    return this.claims.filter(c => !this.isClosed(c)).length;
  }

  /** Dalla più recente: per data di apertura, in mancanza per id */
  get sortedClaims(): Damage[] {
    return [...this.claims].sort((a, b) => {
      const ta = a.damageOpenedAt ? new Date(a.damageOpenedAt).getTime() : 0;
      const tb = b.damageOpenedAt ? new Date(b.damageOpenedAt).getTime() : 0;
      if (ta !== tb) return tb - ta;
      return (b.damageId ?? 0) - (a.damageId ?? 0);
    });
  }

  statusClass(status?: string): string {
    switch (status) {
      case 'OPEN':        return 'claim-pill--open';
      case 'IN_PROGRESS': return 'claim-pill--progress';
      case 'WAITING':     return 'claim-pill--waiting';
      case 'CLOSED':      return 'claim-pill--closed';
      case 'REJECTED':    return 'claim-pill--rejected';
      default:            return '';
    }
  }

  severityClass(severity?: string): string {
    switch (severity) {
      case 'CRITICAL': return 'claim-pill--rejected';
      case 'HIGH':     return 'claim-pill--waiting';
      case 'MEDIUM':   return 'claim-pill--progress';
      case 'LOW':      return 'claim-pill--closed';
      default:         return '';
    }
  }

  trackByClaim(index: number, claim: Damage): number {
    return claim.damageId ?? index;
  }
}
